<ngx-spinner></ngx-spinner>
<section class="container-table">
  <div class="d-flex align-items-center justify-content-between mb-4">
    <div class="page-title">
      <h1 class="fs-4 fw-bold mb-0"> {{contentTypeData?.title}}</h1>
    </div>


    <div class="last-update-text">
      <!-- Last Updated: 24 hrs ago • Updated by: Admin Name -->



      <button class="btn_secondary"
        [routerLink]="['/content-manager/add/'+type]" *ngIf="contentTypeData?.hasAddButton && !contentTypeData?.hasCategoryAdd">
        {{contentTypeData?.add_title}} </button>

        <button class="btn_secondary" (click)="checkIfElementsAdd()"
        *ngIf="contentTypeData?.hasAddButton && contentTypeData?.hasCategoryAdd && (type=='baymount_units')">
        {{contentTypeData?.add_title}} </button>

      <button class="btn_secondary" [routerLink]="['/content-manager/add/'+type+'/'+category_id]"
        *ngIf="contentTypeData?.hasAddButton && contentTypeData?.hasCategoryAdd && (type!='baymount_units') && (contentTypeData?.maxLength ?  dataSource.data.length < contentTypeData?.maxLength : true)">
        {{contentTypeData?.add_title}} </button>

      <div class="col-6" *ngIf="contentTypeData?.hasGroupButtons">
        <div class="btn-group pres ms-auto" role="group"> <button type="button" (click)=" updateData()"
            routerLinkActive="selected" class="btn btn-primary" routerLink="/content-manager/presenters">
            <!--Selected class for white background--> Presenters
          </button> <button type="button" (click)=" updateData()" routerLinkActive="selected" class="btn btn-primary"
            routerLink="/content-manager/ensembles"> Ensembles </button> </div>
      </div>
    </div>
  </div>
  <div class="back-link my-2">
    <a  *ngIf="type=='axa_benefits' || type=='axa_additional_services' || type=='axa_inquiry_projects' " routerLink="/page-manager/offers/page/1"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <polyline points="15 6 9 12 15 18" />
    </svg>back to AXA</a>
    <a  *ngIf="type=='baymount_statistics' || type=='baymount_map' || type=='baymount_masterplan' || type=='baymount_partners'" routerLink="/page-manager/page/24"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <polyline points="15 6 9 12 15 18" />
    </svg>back to Sections</a>
    <a  *ngIf="type=='baymount_units_gallery'" routerLink="/content-manager/baymount_units"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <polyline points="15 6 9 12 15 18" />
    </svg>back to Units</a>
    <a  *ngIf="type=='cali_units_gallery'" routerLink="/content-manager/cali_units"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <polyline points="15 6 9 12 15 18" />
    </svg>back to Units</a>
    </div>
  <div class="row">
    <div class="my-3 col-3" *ngIf="contentTypeData?.hasExportButton">
      <button class="btn_primary" (click)="exportCsv(-1)"> EXPORT EXCEL </button>
    </div>
    <div class="my-3 col-3" *ngIf="contentTypeData?.hasFilter">
    <mat-form-field appearance="outline" >
      <mat-label class="">
        <span>Filter by Offer</span>
      </mat-label>
      <mat-select [(ngModel)]="selectedFilterValue">
       
        <mat-option *ngFor="let filter of filterData" [value]="filter.value" (click)="filteringData(filter.value)">
          {{filter.viewValue}}
        </mat-option>
      </mat-select>

    </mat-form-field>


  </div>
  <div class="my-3 col-3" *ngIf="contentTypeData?.hasSort">
    <mat-form-field appearance="outline">
      <mat-label class="">
        <span>Sort by</span>
      </mat-label>
      <mat-select [(ngModel)]="selectedSortValue" name="sort">
        <mat-option *ngFor="let sort of sorts" [value]="sort.value" (click)="sortData(selectedSortValue)">
          {{sort.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>
    <div class="col-6 d-flex align-items-center justify-content-end " *ngIf="contentTypeData?.hasDateSearch">
      <div class="form-group me-3">
        <div class="date_range">
          <input type="text" name="daterange" autocomplete="off" bsDaterangepicker
            [bsConfig]="{ rangeInputFormat : 'YYYY-MM-DD', dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: false}"
            id="DateOfBirth" placeholder="Select Date Range" (bsValueChange)="dateRangeCreated($event)"
            class="form-control" />
          <mat-icon class="icon" aria-hidden="false"> date_range</mat-icon>
        </div>
      </div>
      <button class="btn_secondary" (click)="handelSearch()">
        Search
      </button>
    </div>
  </div>
  <p class="text-danger" *ngIf="dataSource.data.length >= contentTypeData?.maxLength">*The max length of this section is {{contentTypeData?.maxLength}} items</p>
  <div class="table-responsive">

    <table class="w-100" mat-table [dataSource]="dataSource" matSort>
      <!-- PageName Column -->

      <ng-container *ngFor="let column of displayedColumns;let i=index;">

        <!-- start of columns loop -->
        <ng-container [ngSwitch]="column">
          <!-- start of switch case -->
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'image'">
            <th mat-header-cell  *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="img-team">
                <img [src]="imgUrl+ element[column]" class="img_fit" />
              </div>
            </td>
          </ng-container>
         
            <ng-container matColumnDef="{{column}}" *ngSwitchCase="'logo'">
              <th mat-header-cell  *matHeaderCellDef>{{columnsTitles[i]}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="img-team">
                  <img [src]="imgUrl+ element[column]" class="img_fit" />
                </div>
              </td>
            </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'cover_image'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="img-team">
                <img [src]="imgUrl+ element[column]" class="img_fit" />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'media'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="img-team">
                <img [src]="imgUrl+ element[column]" class="img_fit" />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'icon'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="img-team">
                <img [src]="imgUrl+ element[column]" class="img_fit" />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'number'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element ; let i = index ">
              {{ i+1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'project'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element.project}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'offer'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element.offer}}
            </td>
          </ng-container>
          
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'description'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element" [innerHtml]="element.description | slice: 0:35 ">
             
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'request'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element.request}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'vacancy'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element.vacancy?.title}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'is_active'">
            <th mat-header-cell *matHeaderCellDef> {{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element; index as i">
              <fieldset class="input-toggle">
                <label class="input-toggle-label d-inline-block" for="switch{{i}}">
                  <input type="checkbox" id="switch{{i}}" value="{{element.is_active}}"
                    (change)="checkBoxvalue($event.target.checked, element.id )" [checked]="element.is_active == 1">
                  <span class="switch"></span>
                </label>
              </fieldset>
              <!-- {{element.is_visible}} -->
            </td>
          </ng-container>



          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'title'">
            <th mat-header-cell *matHeaderCellDef>title</th>
            <td mat-cell *matCellDef="let element">
              {{element.title}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'created_at'">
            <th mat-header-cell *matHeaderCellDef>Created at</th>
            <td mat-cell *matCellDef="let element">
              {{element.created_at | date}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'published_at'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element.published_at | date}}
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'address'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              {{element?.address | slice:0 : 20}}...
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'message'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
             <p> {{element?.message | slice: 0:20}}.....</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'cv'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <a class="btn_primary" [href]="imgUrl+element.cv"
              download="{{imgUrl+element.cv}}"
             target="_blank">Download</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'is_featured'">
            <th mat-header-cell *matHeaderCellDef> {{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element; index as i">
              <fieldset class="input-toggle">
                <label class="input-toggle-label d-inline-block" for="switch{{i}}">
                  <input type="checkbox" id="switch{{i}}" value="{{element.is_featured}}"
                    (change)="checkBoxvalue($event.target.checked, element.id )" [checked]="element.is_featured == 1">
                  <span class="switch"></span>
                </label>
              </fieldset>
              <!-- {{element.is_visible}} -->
            </td>
          </ng-container>


          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'deleteOrDetails'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group">
              <button class="btn_secondary" type="button"   [routerLink]="['/content-manager/'+type+'/details/'+element.id]">
                Details
                </button>
                <mat-icon class="ms-3 mt-2" (click)="openDeleteDialog(element)">delete_outline</mat-icon>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'delete'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group">

                <mat-icon class="ms-3 mt-2" (click)="openDeleteDialog(element)">delete_outline</mat-icon>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'editPage'">
            <th mat-header-cell *matHeaderCellDef>Actions </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/edit/'+type+'/'+element.id]"> {{contentTypeData.edit_title}}
                </button>
                <mat-icon class="ms-3 mt-2" (click)="openDeleteDialog(element)" *ngIf="type!='offers'">delete_outline</mat-icon>
                <mat-icon class="ms-3 mt-2" (click)="openDeleteDialog(element)" *ngIf="type=='offers'&& element.is_inner_page!=1">delete_outline</mat-icon>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'edit'">
            <th mat-header-cell *matHeaderCellDef>Actions </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/edit/'+type+'/'+element.id]"> {{contentTypeData.edit_title}}
                </button>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'manage_team'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/list/faq_category/'+element.id]"> {{columnsTitles[i]}}</button>
                </div>

                </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'manage_media'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/list/media/'+element.id]"> {{columnsTitles[i]}}</button>
                </div>

                </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'page_details'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3" *ngIf="element.is_inner_page==1" [routerLink]="['/page-manager/offers/page/'+element.id]"> 
                {{columnsTitles[i]}}
              </button>
                 <!--  -->
                </div>

                </td>
          </ng-container>

          
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'manage_baymount_units'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/list/baymount_units_gallery/'+element.id]"> {{columnsTitles[i]}}</button>
                </div>

                </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'manage_cali_units'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/list/cali_units_gallery/'+element.id]"> {{columnsTitles[i]}}</button>
                </div>

                </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'gallery'">
            <th mat-header-cell *matHeaderCellDef>{{columnsTitles[i]}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/list/media_gallery/'+element.id]"> {{columnsTitles[i]}}</button>
                </div>

                </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchCase="'actionData'">
            <th mat-header-cell *matHeaderCellDef>Actions </th>
            <td mat-cell *matCellDef="let element; let l = index" class="action-link">
              <mat-icon class="mx-2 mt-2" (click)="exportCsv(l)">sim_card_download</mat-icon>
              <div class="btn-group"> <button class="btn_primary me-3"
                  [routerLink]="['/content-manager/'+type+'/details/'+element.id]">{{columnsTitles[i]}}</button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="{{column}}" *ngSwitchDefault>
            <th mat-header-cell *matHeaderCellDef> {{columnsTitles[i]}}</th>
            <td mat-cell *matCellDef="let element"> {{ element[column] }}</td>
          </ng-container>
        </ng-container>
        <!-- end of switch case -->
      </ng-container><!-- start of columns loop -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</section>
